import { render, staticRenderFns } from "./alarmNotice - 副本.vue?vue&type=template&id=15915538&scoped=true&"
import script from "./alarmNotice - 副本.vue?vue&type=script&lang=js&"
export * from "./alarmNotice - 副本.vue?vue&type=script&lang=js&"
import style0 from "./alarmNotice - 副本.vue?vue&type=style&index=0&id=15915538&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15915538",
  null
  
)

export default component.exports